/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const AXsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <defs />
            <g
                id="Temporary-pages"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="smallcard_amex">
                    <g id="shop">
                        <g id="Amex" fill="#3498D8">
                            <path
                                d="M30,0.5 L2,0.5 C0.9,0.5 0,1.4 0,2.5 L0,19.5 C0,20.6 0.9,21.5 2,21.5 L30,21.5 C31.1,21.5 32,20.6 32,19.5 L32,2.5 C32,1.4 31.1,0.5 30,0.5 Z"
                                id="Shape"
                            />
                        </g>
                        <g
                            id="Amex_1_"
                            transform="translate(2.000000, 7.000000)"
                            fill="#FFFFFF"
                        >
                            <path
                                d="M4.7,4.3 L6.3,4.3 L5.5,2.3 L4.7,4.3 Z M27,0.5 L22.9,0.5 L21.9,1.6 L21,0.5 L12.3,0.5 L11.5,2.3 L10.7,0.5 L7.2,0.5 L7.2,1.3 L6.8,0.5 L3.8,0.5 L0.9,7.5 L4.4,7.5 L4.8,6.4 L5.8,6.4 L6.2,7.5 L10.1,7.5 L10.1,6.7 L10.4,7.5 L12.4,7.5 L12.7,6.6 L12.7,7.5 L20.7,7.5 L21.7,6.4 L22.6,7.5 L26.7,7.5 L24.1,4 L27,0.5 Z M14.9,6.5 L13.8,6.5 L13.8,2.6 L12.1,6.5 L11.1,6.5 L9.4,2.6 L9.4,6.5 L7.1,6.5 L6.7,5.4 L4.3,5.4 L3.9,6.5 L2.6,6.5 L4.7,1.5 L6.4,1.5 L8.3,6.2 L8.3,1.5 L10.2,1.5 L11.7,4.9 L13.1,1.5 L15,1.5 L15,6.5 L14.9,6.5 Z M24.8,6.5 L23.3,6.5 L22,4.8 L20.5,6.5 L16,6.5 L16,1.5 L20.6,1.5 L22,3.1 L23.5,1.5 L24.9,1.5 L22.7,4 L24.8,6.5 Z M17.1,2.5 L17.1,3.4 L19.6,3.4 L19.6,4.4 L17.1,4.4 L17.1,5.4 L19.9,5.4 L21.2,3.9 L20,2.5 L17.1,2.5 Z"
                                id="Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

AXsmallcard.defaultProps = { className: '' };

AXsmallcard.propTypes = { className: string };

export default AXsmallcard;
